import { render, staticRenderFns } from "./CiteAttribution.vue?vue&type=template&id=fddd3be8&"
import script from "./CiteAttribution.vue?vue&type=script&lang=js&"
export * from "./CiteAttribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "3da4c0f2"
  
)

/* custom blocks */
import block0 from "./CiteAttribution.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports